import React from 'react';
import styles from './Dashboard.module.css';

export default function DatePeriodSelector({ selectedPeriod, onPeriodChange }) {
  const periods = ['7 days', '30 days', '12 months', 'Custom'];
  
  return (
    <div className={styles.datePeriodSection}>
      {periods.map((period) => (
        <button
          key={period}
          className={`${styles.periodBtn} ${selectedPeriod === period ? styles.activePeriod : ''}`}
          onClick={() => onPeriodChange(period)}
        >
          {period}
        </button>
      ))}
    </div>
  );
} 